import React, { useEffect, useRef } from 'react';
import UserImage from '../UserImage/index';

const SwitchOrg = (props) => {
    const { toggleOrgPopup, data, currentOrgId } = props;
    const orgPopupRef = useRef(null);
    useEffect(() => {
        window.addEventListener("click", handleClickOutside)
        return () => {
            window.removeEventListener('click', handleClickOutside)
        }
    }, [])

    const handleClickOutside = (event) => {
        if (orgPopupRef.current && !orgPopupRef.current.contains(event.target)) {
            
            toggleOrgPopup(false)
        }
    }

    const renderOrgElement = (item, key, isSelected) => {
        return (
            <li key={key} className="userGroup" onClick={() => { isSelected ? null : props.switchOrg(item.org_id) }}>
                <div className="rowFlex">
                    <div className="userPic userPicIcon orgPic">
                        <UserImage profileUrl={item.profile_url} profileName={item.name} />
                    </div>
                    <div className="alignMiddle">
                        <div className="flexGrow flexWrap colFlex">
                            <span className="name">{item.name}</span>
                            <label>{item.city}, {item.state} {item.zip}</label>
                        </div>
                    </div>
                </div>
            </li>
        )
    }

    return (
        <div ref={orgPopupRef} className="dropDownMenu orgPopup openBottom onClick filter">
            <header>
                <ul className="colFlex selectedOrg">
                    {data.length > 0 && renderOrgElement(data.filter(item => item.org_id == currentOrgId)[0], 0, true)}
                </ul>
            </header>
            <h3>Switch Organization</h3>
            <ul className="colFlex orgList">
                {data.map((item, index) => (
                    item.org_id != currentOrgId && renderOrgElement(item, index, false)
                ))}
            </ul>

        </div>
    )
}

export default SwitchOrg